import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { HttpClientCall2j6myj8ctykar as HttpClientCall } from './HttpClientCall.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { HttpRequest3fsc4149kgwfg as HttpRequest } from '../request/HttpRequest.mjs';
import { HttpResponse1532ob1hsse1y as HttpResponse } from '../statement/HttpResponse.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function replaceResponse(_this__u8e3s4, headers, content) {
  headers = headers === VOID ? _this__u8e3s4.f5i().z51() : headers;
  return DelegatedCall().d5k(_this__u8e3s4.a5i_1, _this__u8e3s4, content, headers);
}
var DelegatedCallClass;
function DelegatedCall() {
  if (DelegatedCallClass === VOID) {
    class $ extends HttpClientCall() {
      static d5k(client, originCall, responseContent, responseHeaders) {
        responseHeaders = responseHeaders === VOID ? originCall.f5i().z51() : responseHeaders;
        var $this = this.e5k(client);
        $this.c5i_1 = new (DelegatedRequest())($this, originCall.f5k());
        $this.d5i_1 = new (DelegatedResponse())($this, originCall.f5i(), responseContent, responseHeaders);
        return $this;
      }
    }
    initMetadataForClass($, 'DelegatedCall', VOID, VOID, VOID, [0, 1]);
    DelegatedCallClass = $;
  }
  return DelegatedCallClass;
}
var DelegatedRequestClass;
function DelegatedRequest() {
  if (DelegatedRequestClass === VOID) {
    class $ {
      constructor(call, origin) {
        this.k5k_1 = origin;
        this.l5k_1 = call;
      }
      m5k() {
        return this.l5k_1;
      }
      dw() {
        return this.k5k_1.dw();
      }
      n5k() {
        return this.k5k_1.n5k();
      }
      o5k() {
        return this.k5k_1.o5k();
      }
      g5k() {
        return this.k5k_1.g5k();
      }
      s2o() {
        return this.k5k_1.s2o();
      }
      z51() {
        return this.k5k_1.z51();
      }
    }
    initMetadataForClass($, 'DelegatedRequest', VOID, VOID, [HttpRequest()]);
    DelegatedRequestClass = $;
  }
  return DelegatedRequestClass;
}
var DelegatedResponseClass;
function DelegatedResponse() {
  if (DelegatedResponseClass === VOID) {
    class $ extends HttpResponse() {
      constructor(call, origin, content, headers) {
        headers = headers === VOID ? origin.z51() : headers;
        super();
        this.p5k_1 = call;
        this.q5k_1 = origin;
        this.r5k_1 = content;
        this.s5k_1 = headers;
        this.t5k_1 = this.q5k_1.dw();
      }
      m5k() {
        return this.p5k_1;
      }
      z51() {
        return this.s5k_1;
      }
      u5k() {
        return this.r5k_1(this.q5k_1);
      }
      dw() {
        return this.t5k_1;
      }
      v5k() {
        return this.q5k_1.v5k();
      }
      w5k() {
        return this.q5k_1.w5k();
      }
      x5k() {
        return this.q5k_1.x5k();
      }
      y5k() {
        return this.q5k_1.y5k();
      }
    }
    initMetadataForClass($, 'DelegatedResponse');
    DelegatedResponseClass = $;
  }
  return DelegatedResponseClass;
}
//region block: exports
export {
  replaceResponse as replaceResponse3ut5eo3odxj99,
};
//endregion

//# sourceMappingURL=DelegatedCall.mjs.map
